import { render, staticRenderFns } from "./NuevasAltasComponent.vue?vue&type=template&id=0b37d4dc&scoped=true"
import script from "./NuevasAltasComponent.vue?vue&type=script&lang=js"
export * from "./NuevasAltasComponent.vue?vue&type=script&lang=js"
import style0 from "./NuevasAltasComponent.vue?vue&type=style&index=0&id=0b37d4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37d4dc",
  null
  
)

export default component.exports